<div [formGroup]="form">
  <div class="geofence-form">
    <osp-form-field>
      <osp-label>{{ 'general.designation' | translate }}</osp-label>
      <osp-input-text [formControlName]="'geofenceName'" />
      <osp-error
        [messages]="{
          required: 'shared.validation.requiredField' | translate,
          geofenceExists: 'shared.geofence.nameAlreadyExists' | translate,
          maxlength: 'shared.validation.maxCharacters' | translate: { value: nameMaxLength }
        }"
      >
      </osp-error>
    </osp-form-field>
    <osp-form-field>
      <osp-label>{{ 'shared.geofence.color' | translate }}</osp-label>
      <osp-dropdown [formControlName]="'geofenceColor'" [options]="colors">
        <ng-template ospTemplate="selectedItem" let-color>
          <ng-container *ngTemplateOutlet="tmplColorItem; context: { $implicit: color }"></ng-container>
        </ng-template>
        <ng-template ospTemplate="item" let-color>
          <ng-container *ngTemplateOutlet="tmplColorItem; context: { $implicit: color }"></ng-container>
        </ng-template>
      </osp-dropdown>
    </osp-form-field>
  </div>
  <osp-action-panel [actions]="$actions()" />
</div>

<ng-template #tmplColorItem let-color>
  <div class="flex gap-2">
    <osp-color-marker [color]="color.value" />
    <span>{{ color.label }}</span>
  </div>
</ng-template>
